import { render, staticRenderFns } from "./profesional-el.vue?vue&type=template&id=2b3d754e"
import script from "./profesional-el.vue?vue&type=script&lang=js"
export * from "./profesional-el.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports